// extracted by mini-css-extract-plugin
module.exports = {"statsCard":"StatsCard_statsCard__LEe_N","statsRow":"StatsCard_statsRow__3cHLK"};